import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as cartCallsActionCreators from '../../../../actionCreators/cart';
import * as commonCallsActionCreators from '../../../../actionCreators/common';
import * as productCallsActionCreators from '../../../../actionCreators/product';
import getSetCookie from '../../../../cookie';
import { pushDataLayerEvent } from '../../../../utils/DataLayer';
import { triggerDataLayerOnPageView } from '../../../../utils/googleAnalytics';
import {
  disableBackgroundScroll,
  discountCalculator,
  enableBackgroundScroll,
  getProductType,
} from '../../../../utils/helper';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import { AddToCartTikTokEvent } from '../../../../utils/tiktokPixel';
import Carousel from '../../Carousel/Carousel';
import Logo from '../../MainNav/Logo';
import LKModal from '../../Modal/Modal';
import NavigationDrawer from '../../NavigationDrawer/NavigationDrawer';
import AddPackageCoatings from './AddPackageCoatingsModalLoadable';
import EyePowerSubmitInfo from './EyePowerSubmitInfo';
import LensOnlyAvailability from './LensOnlyAvailability';
import PackagesModal from './PackagesModal';
import PowerTypeModal from './PowerTypeModal';
import PowerTypeModalHeader from './PowerTypeModalHeader';
import PrescriptionDetailsModal from './PrescriptionDetailsLoadable';
import './SelectPowerTypes.scss';
import NearByStoreAppointment from './StoreAppointment/Loadable';
import TryOnPopUp from './TryOnPopUp';

class SelectPowerTypes extends PureComponent {
  static propTypes = {
    productData: PropTypes.object,
    redisCommonData: PropTypes.object,
    getLensPackages: PropTypes.func,
    LensPackage: PropTypes.any,
    enterLocationAddToCart: PropTypes.object,
  };
  constructor(props, context) {
    super(props, context);
    const { LENS_TYPE, EYE_POWER_TYPE, POWER_TYPE } = props.dataLocale || {};
    this.state = {
      selectedPowerType: '',
      isChecked: true,
      itemQtyValue: '1',
      lensPincodeInput: '',
      showNearBy: false,
      showTryOnPopUp: false,
      showPowerTypeModal: false,
      showRedirectPopup: false,
      powerTab: {
        data: [
          { value: null, label: POWER_TYPE, disabled: false },
          { value: null, label: LENS_TYPE, disabled: true },
          { value: null, label: EYE_POWER_TYPE, disabled: true },
        ],
        selectedIndex: 0,
        type: null,
      },
      offerModalBtnClicked: null,
      isWindows: false,
    };
    this.showSkipCoatingModal = this.showSkipCoatingModal.bind(this);
    this.displayRedirectPopup = this.displayRedirectPopup.bind(this);
    this.coatingModalClose = this.coatingModalClose.bind(this);
    this.fnCreateMyDitto = this.fnCreateMyDitto.bind(this);
    this.sendDTM = this.sendDTM.bind(this);
    this.showNearByPopup = this.showNearByPopup.bind(this);
    this.close = this.close.bind(this);
    this.showSkipPowerTypeModal = this.showSkipPowerTypeModal.bind(this);
    this.setPowerType = this.setPowerType.bind(this);
    this.closePowerTypeModal = this.closePowerTypeModal.bind(this);
    this.changeLensPackageTab = this.changeLensPackageTab.bind(this);
    this.btnAddToCartWithPower = this.btnAddToCartWithPower.bind(this);
    this.isExchange =
      (sessionStorageHelper.getItem('exchangeMethod') === 'NEWPRODUCT' &&
        sessionStorageHelper.getItem('exchangeNP') === true) ||
      null;
    this.isWindows = false;
    this.newCartFlowEnable = false;
  }

  componentDidMount() {
    // const { prescriptionType } = this.props.productData;
    // let defPowerType;
    // prescriptionType.forEach(powerType => {
    //     if (powerType.isDefault) {
    //         defPowerType = powerType.id;
    //     }
    // });
    // this.setPowerType(defPowerType);
    if (localStorage.getItem('dittoCompare') + '?3dtryon=true' === window.location.href) {
      (() => this.setState({ showTryOnPopUp: true }))();
    }
    if (navigator.platform?.indexOf('Win') > -1) {
      (() => this.setState({ isWindows: true }))();
    }
  }

  componentDidUpdate() {
    // Offer modal : on click continue handling on success screen in offer modal
    const { isContinueClickedInOfferModalSuccess, pdp_ipl, renderOfferModal } = this.props;
    const { offerModalBtnClicked } = this.state;
    if (pdp_ipl && isContinueClickedInOfferModalSuccess && offerModalBtnClicked) {
      if (offerModalBtnClicked.name === 'btnAddToCartWithPower') {
        this.btnAddToCartWithPower();
      } else {
        this.addToCart(...offerModalBtnClicked.param);
      }
      (() => {
        this.setState({ offerModalBtnClicked: null });
      })();
      renderOfferModal(false);
    }

    // if (this.props.productData.id !== prevProps.productData.id) {
    //     const { prescriptionType } = this.props.productData;
    //     let defPowerType;
    //     prescriptionType.forEach(powerType => {
    //         if (powerType.isDefault) {
    //             defPowerType = powerType.id;
    //         }
    //     });
    //     this.setPowerType(defPowerType);
    // }
  }
  getUrlQueryPackage = () => {
    const query = this.props.location.search.substr(1);
    const result = {};
    query.split('&').forEach(param => {
      const item = param.split('=');
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result.package;
  };

  setPowerType = (event, type) => {
    const { productData, login } = this.props;
    const dlUpdate = {};
    dlUpdate.event = 'selectLens';
    dlUpdate.selectLensSection = 'Prescription type';
    dlUpdate.selectLensOptionChosen = type.id;
    pushDataLayerEvent(dlUpdate);
    this.setState({ selectedPowerType: type.id, showPowerTypeModal: true }, () => {
      _gaq.push(
        ['_trackEvent', 'Product Page', type.id],
        ['ninja._trackEvent', 'Product Page', type.id]
      );
      if (type.id === 'single_vision' || type.id === 'bifocal' || type.id === 'tinted_sv') {
        _gaq.push(
          [
            '_trackEvent',
            'Product Page',
            'Add Lens/Add Power',
            `page: ${document.location.hostname + document.location.pathname}`,
          ],
          [
            'ninja._trackEvent',
            'Product Page',
            'Add Lens/Add Power',
            `page: ${document.location.hostname + document.location.pathname}`,
          ]
        );
      }
      if (event?.target?.value) {
        if (event.target.value === 'zero_power') {
          _gaq.push(
            [
              '_trackEvent',
              'Product Page',
              type.id,
              `page: ${document.location.hostname + document.location.pathname}`,
            ],
            [
              'ninja._trackEvent',
              'Product Page',
              type.id,
              `page: ${document.location.hostname + document.location.pathname}`,
            ]
          );
        }
        if (event.target.value === 'frame_only') {
          const ecommerce = { items: [] };
          const product = {
            item_id: productData.id,
            item_name: productData.modelName,
            coupon: '',
            alliliation: '',
            currency: productData?.prices[0]?.currencyCode,
            discount: discountCalculator(productData.prices),
            index: 1,
            item_brand: productData.brandName,
            item_category: getProductType(productData.sku),
            item_category2: '',
            item_category3: '',
            item_category4: '',
            item_category5: '',
            item_list_id: '',
            item_list_name: '',
            item_variant: productData.color,
            price: productData.prices.filter(priceObj => priceObj.name === 'Lenskart Price')[0]
              ?.price,
            quantity: 1,
          };
          ecommerce.items.push(product);
          triggerDataLayerOnPageView({ loginStatus: login, ecommerce, event: 'add_to_cart' });
          _gaq.push(
            ['_link', window.location.href],
            [
              '_trackEvent',
              'A2C Popup',
              'Click',
              `page: ${document.location.pathname + document.location.search}`,
            ],
            [
              'ninja._trackEvent',
              'A2C Popup',
              'Click',
              `page: ${document.location.pathname + document.location.search}`,
            ]
          );
        }
      }
      this.props.productCallsAction.setPowerType(type.id);
      const FirstBuyPrice = productData?.prices?.find(key => key.name === 'First Buy Price');
      if (FirstBuyPrice) {
        this.btnAddToCartWithPower(event, type);
      } else if (type.id !== 'frame_only') {
        this.btnAddToCartWithPower(event, type);
      } else {
        this.addToCart(event);
        this.closePowerTypeModal();
      }
    });
  };

  getButtonLabelDesc = (label, desc) => {
    const { redisCommonData, productData } = this.props;
    let btnLabelConfig = redisCommonData && redisCommonData.ADDTOCART_BUTTON_CONFIG;
    if (btnLabelConfig) {
      btnLabelConfig = JSON.parse(btnLabelConfig);
      const brandName = productData.brandName;
      let frameType;
      const technicalSpecs = productData.specifications[1].items;
      technicalSpecs.forEach(spec => {
        if (spec.name === 'Frame Type') {
          frameType = spec.value;
        }
      });
      const price =
        productData.prices.length === 3 ? productData.prices[2].price : productData.prices[1].price;
      const btnConfig = btnLabelConfig[`${brandName}_${frameType}`];
      if (btnConfig) {
        if (btnConfig[price]) {
          label = btnConfig[price].label;
          desc = btnConfig[price].desc;
        } else {
          Object.keys(btnConfig).forEach(key => {
            if (key?.indexOf('_') > 0) {
              const priceRange = key.split('_');
              const minRange = Number(priceRange[0]);
              const maxRange = Number(priceRange[1]);
              if (minRange <= price && price <= maxRange) {
                label = btnConfig[key].label;
                desc = btnConfig[key].desc;
              }
            }
          });
        }
      }
    }
    return [
      label,
      <span key="btnDesc" className="fs11">
        {desc}
      </span>,
    ];
  };
  getCarouselInfo(imageUrls) {
    const retData = {};
    retData.settings = {
      dots: true,
      slidesToShow: 1,
      arrows: false,
      pauseOnHover: true,
      adaptiveHeight: true,
    };
    retData.htmlData = imageUrls.map((url, index) => {
      return (
        <div key={`carousel-html-banner${index}`}>
          <img
            alt={`product-spec-${index}`}
            className="margin-0-auto"
            src={url}
            style={{ maxWidth: '308px' }}
          />
        </div>
      );
    });
    return retData;
  }
  toggleChange = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    });
  };
  hecFrameFunction = evt => {
    const hecFrameValue = evt.currentTarget.innerText || '';
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.Pdp.click.hecFrame(hecFrameValue.trim());
  };

  handleChange = event => {
    this.setState({ lensPincodeInput: event.target.value });
  };

  pickLocationaddTocart = () => {
    const { lensPincodeInput } = this.state;
    const regex = /^[0-9]+$/;
    if (lensPincodeInput !== '' && regex.test(lensPincodeInput) && lensPincodeInput.length === 6) {
      this.props.productCallsAction.lensOnlyLocation(lensPincodeInput);
      this.setState({ invalidPinCode: false });
    } else {
      this.setState({ invalidPinCode: true });
    }
  };

  itemChangeValue(event) {
    if (event.target.value > -1) {
      this.setState({ itemQtyValue: event.target.value });
    }
  }

  itemOnBlurHandler(event) {
    if (event.target.value < 1) {
      this.setState({ itemQtyValue: 1 });
    }
  }

  btnAddToCartWithPower(event, type) {
    const { renderOfferModal, isRepeatUser, pdp_ipl, isContinueClickedInOfferModalSuccess } =
      this.props;
    // Offer Modal : If user hasPlacedOrder is false then open offer modal else normal flow.
    if (pdp_ipl && renderOfferModal && !isRepeatUser && !isContinueClickedInOfferModalSuccess) {
      renderOfferModal(true);
      this.setState({
        offerModalBtnClicked: {
          name: 'btnAddToCartWithPower',
        },
      });
    } else {
      // PackagesModal.preload();
      AddPackageCoatings.preload();
      PrescriptionDetailsModal.preload();
      const { productData, productCallsAction } = this.props;
      const { powerTab } = this.state;
      const { classification, prices } = productData;
      const lenskartPrice = prices?.filter(p => p.name === 'Lenskart Price');
      if (event) {
        event.preventDefault();
      }
      let frameType = null;
      let powerType = null;
      const isExpress =
        productData.deliveryOptions && productData.deliveryOptions[0].deliveryOption === 'EXPRESS';
      // window.ReactPixel.default.track('AddToCart', {
      //   content_type: 'product',
      //   content_ids: productData?.id,
      //   value: lenskartPrice[0]?.price,
      //   content_name: classification,
      //   currency: lenskartPrice[0]?.currencyCode,
      // });
      if (productData.type === 'Eyeglasses') {
        productData.specifications.forEach(data => {
          data.items.forEach(val => {
            if (val.name === 'Frame Type') {
              frameType = val.value;
            }
          });
        });
        powerType = this.state.selectedPowerType;
        if (window.dtm.LenskartRewamp)
          window.dtm.LenskartRewamp.Pdp.click.selectLenses(powerType.replace('_', ' '));
      }
      if (productData.type === 'Sunglasses') {
        productData.specifications.forEach(data => {
          data.items.forEach(val => {
            if (val.name === 'Frame Type') {
              frameType = val.value;
            }
          });
        });
        powerType = 'sunglasses';
        if (window.dtm.LenskartRewamp)
          window.dtm.LenskartRewamp.Pdp.click.selectLenses(powerType.replace('_', ' '));
      }
      if (powerType !== undefined && powerType !== 'frame_only') {
        productCallsAction.getLensPackages(
          productData.id,
          powerType,
          frameType,
          isExpress,
          this.getUrlQueryPackage()
        );
      }
      const d = { ...powerTab };
      d.type = powerType;
      d.data[1].disabled = false;
      if (type) {
        d.data[0].value = type.title;
        d.data[1].value = '';
      }
      this.setState({
        showPackagesModal: true,
        showCoatingModal: false,
        powerTab: { ...d, selectedIndex: 1 },
      });
      this.showSkipPowerTypeModal(true);
    }
  }

  showSkipCoatingModal(getPackage) {
    const { redisCommonData, productData } = this.props;
    const { powerTab, selectedPowerType } = this.state;
    if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.Pdp.click.addToCart(productData);
    if (redisCommonData && redisCommonData.SKIP_COATINGS_STEP === 'ON') {
      this.addToCart(getPackage);
      this.closePowerTypeModal();
      return;
    }
    const d = { ...powerTab };
    if (getPackage) {
      d.data[1].value = getPackage.name;
    }
    this.setState(
      {
        selectedLensPackage: getPackage,
        powerTab: { ...d, selectedIndex: 1 },
      },
      () => {
        if (getPackage.addons && getPackage.addons.length) {
          const powerType = this.state.selectedPowerType.replace('_', ' ');
          const packageName = getPackage.subtitle || getPackage.name;
          if (window.dtm.LenskartRewamp)
            window.dtm.LenskartRewamp.Pdp.click.addToCartLensPackage(packageName, powerType);
          this.setState({ showPackagesModal: false, showCoatingModal: true });
        } else {
          if (selectedPowerType === 'zero_power') {
            this.addToCart(getPackage);
            this.closePowerTypeModal();
            return;
          }
          this.setState({
            showPackagesModal: false,
            showCoatingModal: false,
            powerTab: { ...d, selectedIndex: 2 },
          });
        }
      }
    );
  }

  coatingModalClose(isCoating) {
    const { powerTab, selectedLensPackage, selectedPowerType } = this.state;
    const d = { ...powerTab };
    if (selectedPowerType === 'zero_power') {
      this.addToCart(selectedLensPackage);
      this.closePowerTypeModal();
      return;
    }
    const dlUpdate = {};
    dlUpdate.event = 'selectLens';
    dlUpdate.selectLensSection = 'Coating Added';
    dlUpdate.selectLensOptionChosen = 'No';
    pushDataLayerEvent(dlUpdate);
    this.setState(
      {
        showCoatingModal: false,
        selectedCoating: null,
        powerTab: { ...d, selectedIndex: 2 },
        addonsTotal: 0,
      },
      () => {
        if (window.dtm.LenskartRewamp) {
          if (isCoating > 0) {
            // window.dtm.LenskartRewamp.Pdp.click.addSkipCoating('coating applied|skip');
            window.dtm.LenskartRewamp.Pdp.click.newGa('lensDescription', { coating: 'No' });
          } else {
            // window.dtm.LenskartRewamp.Pdp.click.addSkipCoating('apply coating|skip');
            window.dtm.LenskartRewamp.Pdp.click.newGa('lensDescription', { coating: 'No' });
          }
        }
      }
    );
  }

  addCoating = (getPackage, coatings, addonsTotal) => {
    const { powerTab, selectedPowerType } = this.state;
    const d = { ...powerTab };
    if (selectedPowerType === 'zero_power') {
      this.addToCart(getPackage, coatings);
      this.closePowerTypeModal();
      return;
    }
    const dlUpdate = {};
    dlUpdate.event = 'selectLens';
    dlUpdate.selectLensSection = 'Coating Added';
    dlUpdate.selectLensOptionChosen = 'Yes';
    pushDataLayerEvent(dlUpdate);
    this.setState({
      showPackagesModal: false,
      showCoatingModal: false,
      selectedLensPackage: getPackage,
      selectedCoating: coatings,
      powerTab: { ...d, selectedIndex: 2 },
      addonsTotal,
    });
  };

  addToCart = (getPackage, coatings) => {
    const { renderOfferModal, isRepeatUser, pdp_ipl, isContinueClickedInOfferModalSuccess } =
      this.props;
    // Offer Modal : If user hasPlacedOrder is false then open offer modal else normal flow.
    if (pdp_ipl && renderOfferModal && !isRepeatUser && !isContinueClickedInOfferModalSuccess) {
      renderOfferModal(true);
      this.setState({
        offerModalBtnClicked: {
          name: 'addToCart',
          param: [getPackage, coatings],
        },
      });
    } else {
      const { productData, cartCallsAction, commonCallsAction } = this.props; // redisCommonData
      const { classification, prices } = productData;
      const pkgPrice = (getPackage && getPackage.prices && getPackage.prices[1].price) || 0;
      const lenskartPrice = prices?.filter(p => p.name === 'Lenskart Price');
      let addOnsPrice = 0;
      if (coatings && coatings !== null && getPackage?.addons?.length > 0) {
        const addOnsPrices = getPackage.addons[0].prices;
        addOnsPrice = addOnsPrices[1].price;
      }
      const displayPrice = pkgPrice + lenskartPrice[0]?.price + addOnsPrice;
      const obj = {};
      if (this.state.isChecked && productData.crossSells.length) {
        obj.relatedProductIds = [productData.crossSells[0].id];
      }
      if (classification === 'eyeframe') {
        obj.powerType = this.state.selectedPowerType;
      } else if (
        classification === 'sunglasses' &&
        productData.prescriptionType.length > 1 &&
        getPackage !== 'normal'
      ) {
        obj.powerType = 'sunglasses';
      }
      obj.productId = productData.id && Number(productData.id);
      if (getPackage.id) {
        obj.packageId = getPackage.id;
        obj.addOns = coatings;
      } else {
        obj.packageId = '';
      }
      if (this.refs.qtyValue !== undefined) {
        obj.quantity = this.refs.qtyValue.value;
      }
      if (this.isExchange) {
        // obj.orderId = sessionStorageHelper.getItem('exchangeOrderId');
        obj.orderId = getSetCookie.getCookie('exchangeOrderId');
        const returnProductDetails = sessionStorageHelper.getItem('returnProduct') || {};
        obj.itemId = returnProductDetails && returnProductDetails.returnProductId;
      }
      cartCallsAction.addToCart(obj, this.getUrlQueryPackage());
      this.setState({ showPackagesModal: false, showCoatingModal: false });
      // prescription modal show/hide
      // if (getPackage.id && redisCommonData && redisCommonData.PRESCRIPTION_MODAL === 'ON' && this.state.selectedPowerType !== 'zero_power') {
      //     this.setState({ showPresDetailsModal: true });
      // } else {
      commonCallsAction.toggleCart(true, 'add');
      this.closePowerTypeModal();
      // }
      window.ReactPixel.default.track('AddToCart', {
        content_type: 'product',
        content_ids: productData?.id,
        value: displayPrice,
        content_name: classification,
        currency: lenskartPrice[0]?.currencyCode,
      });
      AddToCartTikTokEvent({
        currency: lenskartPrice[0]?.currencyCode,
        productId: productData?.id,
        productName: classification,
        productPrice: displayPrice,
      });
      if (window.dtm.LenskartRewamp) {
        if (getPackage.id) {
          const powerType = this.state.selectedPowerType.replace('_', ' ');
          const packageName = getPackage.subtitle || getPackage.name;
          window.dtm.LenskartRewamp.Pdp.click.addToCartLensPackage(packageName, powerType);
        } else {
          window.dtm.LenskartRewamp.Pdp.click.addToCart(productData);
        }
      }
    }
    this.newCartFlowEnable = !!(
      this.props?.redisCommonData &&
      this.props?.redisCommonData?.NEW_CART_FLOW_DESKTOP &&
      JSON.parse(this.props.redisCommonData?.NEW_CART_FLOW_DESKTOP)?.enable === 'ON'
    );
    if (this.newCartFlowEnable && !this.isExchange) {
      this.props.history.push('/cart');
    }
  };

  goToBackStep = () => {
    this.setState({
      showCoatingModal: false,
      showPackagesModal: true,
      selectedCoating: null,
    });
  };

  lensPackageModalClose = () => {
    this.setState({
      showPackagesModal: false,
    });
    const powerType = this.state.selectedPowerType;
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.Pdp.click.lensPackageClose(powerType.replace('_', ' '));
  };

  prescriptionModalClose = () => {
    if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.Pdp.click.prescriptionInfoModal();
    this.props.commonCallsAction.toggleCart(true, 'add');
  };

  fnCreateMyDitto(cta, product) {
    this.sendDTM(cta, product);
    if (getSetCookie.getCookie('isDittoID')) {
      this.setState({ showTryOnPopUp: true });
      this.props.updateTryOnSwitch();
    } else {
      localStorage.setItem('dittoCompare', window.location.href);
      window.location.href = '/compare-looks';
    }
  }
  sendDTM(cta, product) {
    const category = product.type;
    const subCategory = product.subCategories;
    const productId = product.id;
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.ditto.click.pdp.triggerDTM(category, subCategory, productId, cta);
  }
  showNearByPopup(type) {
    this.setState({
      showNearBy: type,
    });
  }
  close() {
    this.setState({ showTryOnPopUp: false });
  }
  showSkipPowerTypeModal(show) {
    const { showPowerTypeModal } = this.state;
    this.setState({ showPowerTypeModal: show || !showPowerTypeModal });
    disableBackgroundScroll();
  }

  changeLensPackageTab(index) {
    const { powerTab, selectedLensPackage, selectedCoating } = this.state;
    this.setState({
      showPackagesModal: true,
      showCoatingModal: false,
      powerTab: { ...powerTab, selectedIndex: index },
      selectedLensPackage: index === 0 ? null : selectedLensPackage,
      selectedCoating: index === 0 || index === 1 ? null : selectedCoating,
    });
  }

  closePowerTypeModal() {
    const { LENS_TYPE, EYE_POWER_TYPE, POWER_TYPE } = this.props.dataLocale || {};
    this.setState({
      selectedPowerType: '',
      showPowerTypeModal: false,
      powerTab: {
        type: null,
        data: [
          { value: null, label: POWER_TYPE, disabled: false },
          { value: null, label: LENS_TYPE, disabled: true },
          { value: null, label: EYE_POWER_TYPE, disabled: true },
        ],
        selectedIndex: 0,
      },
      selectedLensPackage: null,
      selectedCoating: null,
    });
    enableBackgroundScroll();
  }

  displayRedirectPopup() {
    this.closePowerTypeModal();
    this.setState({ showRedirectPopup: true });
  }

  continueEyePower() {
    const { selectedCoating, selectedLensPackage } = this.state;
    this.addToCart(selectedLensPackage, selectedCoating);
    this.prescriptionModalClose();
    this.closePowerTypeModal();
    const dlUpdate = {};
    dlUpdate.event = 'selectLens';
    dlUpdate.selectLensSection = 'Upload prescription';
    dlUpdate.selectLensOptionChosen = 'Later';
    pushDataLayerEvent(dlUpdate);
  }

  render() {
    const {
      productData,
      enterLocationAddToCart,
      redisCommonData,
      frameType,
      frameShape,
      dataLocale,
      isLoader,
      currencyMark,
      exchangeBalance,
      modifiedProductData,
      appLogo,
    } = this.props;
    const {
      showNearBy,
      selectedPowerType,
      invalidPinCode,
      itemQtyValue,
      showPackagesModal,
      showCoatingModal,
      selectedLensPackage,
      showTryOnPopUp,
      showPowerTypeModal,
      powerTab,
      selectedCoating,
      addonsTotal,
      isWindows,
      showRedirectPopup,
    } = this.state;
    const { DITTO_CONFIG, EXCHANGE_CONFIG, STUDIO_FLOW } = redisCommonData;
    const { frameColour, type, imageUrls } = productData;
    const { selectedIndex } = powerTab;
    const {
      BUY_NOW_CAPS,
      TRY_ON,
      QUANTITY,
      GET_YOUR_FIRST_FRAME_FREE,
      WITH_1_YEAR_WARRANTY_14_DAY_RETURN,
      WITH_1_YEAR_WARRANTY,
      SELECT_LENSES,
      ADD_POWER,
      ITEM_CURRENTLY_ON_APP,
      SCAN_QR_TO_DOWNLOAD_AND_PROCEED,
    } = dataLocale || {};
    const isEye = productData.classification === 'eyeframe';
    const isSun = productData.classification === 'sunglasses';
    const isAccessories = productData.classification === 'accessories_revenue';
    const isPharmaAccessories = productData.classification.toLowerCase() === 'pharma';
    const isNonPower = productData.classification === 'non_power_reading';
    const isClSolution = productData.classification === 'contact_lens_solution';
    // const storeLocatorUrl = STORE_LOCATOR_URL || 'https://stores.lenskart.com/';
    const dittoConfig = DITTO_CONFIG && JSON.parse(DITTO_CONFIG);
    const studioFlow = STUDIO_FLOW && JSON.parse(STUDIO_FLOW);
    const isTryOnSwitchCTA = redisCommonData.ENABLE_CYGNUS
      ? productData && productData?.isCygnusEnabled
      : dittoConfig &&
        dittoConfig.isDittoEnableGlobal === 'ON' &&
        productData &&
        productData.isDittoEnabled;
    // let pdpCTA = {};
    // const pdpCTAConfig = PDP_CTA_CONFIG && JSON.parse(redisCommonData.PDP_CTA_CONFIG);
    // pdpCTA = pdpCTAConfig && pdpCTAConfig[0];
    // const nearByStore = pdpCTA && pdpCTA.buttonName[1];
    // const nearByStoreBtnText = nearByStore && nearByStore.CTA;
    // condition to show "Add to Cart" for Eyeglass case
    const packagesConfig =
      redisCommonData?.PACKAGES_CONFIG && JSON.parse(redisCommonData.PACKAGES_CONFIG);
    const displayPrice = modifiedProductData?.firstFrameFree
      ? modifiedProductData?.firstFrameFreePrice
      : modifiedProductData?.lenskartPrice;
    let btnAddToCartForEye = null;
    let btnAddToCartForSun = null;
    let btnAddToCartForAccessories = null;
    let btnAddToCartForNonPower = null;
    let carouselInfo = null;
    if (isEye) {
      productData.prices.map(key => {
        if (key.name === 'First Buy Price') {
          btnAddToCartForEye = (
            <button
              className="btn btn-topaz text-color-white bg-color-primary buy-now-btn"
              onClick={() => this.showSkipPowerTypeModal()}
            >
              {this.getButtonLabelDesc(
                GET_YOUR_FIRST_FRAME_FREE,
                `(${WITH_1_YEAR_WARRANTY_14_DAY_RETURN})`
              )}
            </button>
          );
        } else if (selectedPowerType !== 'frame_only') {
          btnAddToCartForEye = (
            <React.Fragment>
              {productData.brandName === 'Lenses Only' ? (
                <button
                  className="btn btn-topaz bg-color-primary buy-now-btn"
                  disabled={
                    enterLocationAddToCart === null ||
                    enterLocationAddToCart.code !== 'SUCCESS' ||
                    enterLocationAddToCart.code === 'REVERSE_PICKUP_NOT_AVAILABLE'
                  }
                  onClick={ev => this.showSkipPowerTypeModal(ev)}
                >
                  {this.getButtonLabelDesc(SELECT_LENSES, '')}
                </button>
              ) : (
                <button
                  className="btn btn-topaz bg-color-primary buy-now-btn"
                  onClick={() => this.showSkipPowerTypeModal()}
                >
                  {this.getButtonLabelDesc(
                    SELECT_LENSES,
                    `(${WITH_1_YEAR_WARRANTY_14_DAY_RETURN})`
                  )}
                </button>
              )}
            </React.Fragment>
          );
        } else {
          btnAddToCartForEye = (
            <button
              className="btn btn-topaz bg-color-primary buy-now-btn"
              onClick={() => this.showSkipPowerTypeModal()}
            >
              {this.getButtonLabelDesc(SELECT_LENSES, `(${WITH_1_YEAR_WARRANTY_14_DAY_RETURN})`)}
            </button>
          );
        }
        return btnAddToCartForEye;
      });
    }
    if (
      isSun &&
      productData.brandName === 'Lenses Only' &&
      productData.prescriptionType.length > 1
    ) {
      btnAddToCartForSun = (
        <button
          className="btn btn-topaz add-power-btn btn-add-power"
          onClick={ev => this.btnAddToCartWithPower(ev)}
        >
          {ADD_POWER}
          <span className="fs11">({WITH_1_YEAR_WARRANTY})</span>
        </button>
      );
    }
    if (
      isSun &&
      productData.brandName !== 'Lenses Only' &&
      productData.prescriptionType.length > 1
    ) {
      btnAddToCartForSun = (
        <React.Fragment>
          <button
            className="btn btn-topaz bg-color-primary buy-now-btn"
            unbxdattr="AddToCart"
            unbxdparam_sku={productData.productId}
            onClick={() => this.addToCart('normal')}
          >
            {BUY_NOW_CAPS}
            <span className="fs11 ls-btn">({WITH_1_YEAR_WARRANTY})</span>
          </button>
          <button
            className="btn btn-topaz add-power-btn btn-add-power"
            onClick={ev => this.btnAddToCartWithPower(ev)}
          >
            {ADD_POWER}
            <span className="fs11 ls-btn">({WITH_1_YEAR_WARRANTY})</span>
          </button>
        </React.Fragment>
      );
    }
    if (
      isSun &&
      productData.brandName !== 'Lenses Only' &&
      productData.prescriptionType.length === 1
    ) {
      btnAddToCartForSun = (
        <button
          className="btn btn-topaz bg-color-primary buy-now-btn"
          unbxdattr="AddToCart"
          unbxdparam_sku={productData.productId}
          onClick={() => this.addToCart('normal')}
        >
          {BUY_NOW_CAPS}
          <span className="fs11 ls-btn">({WITH_1_YEAR_WARRANTY})</span>
        </button>
      );
    }
    if (
      (isPharmaAccessories && productData.brandName === 'Lenskart PLUS') ||
      (isAccessories &&
        (productData.sku?.indexOf('watch:') !== -1 ||
          productData.brandName === 'Vincent Chase' ||
          productData.brandName === 'Lenskart' ||
          productData.brandName === 'Aqualens')) ||
      (isClSolution &&
        productData.sku?.indexOf('watch:') !== -1 &&
        productData.brandName === 'Aqualens')
    ) {
      btnAddToCartForAccessories = (
        <button
          className="btn btn-topaz bg-color-primary buy-now-btn"
          onClick={ev => this.addToCart(ev)}
        >
          {BUY_NOW_CAPS}
        </button>
      );
    }
    if (isNonPower) {
      btnAddToCartForNonPower = (
        <button
          className="btn btn-topaz bg-color-primary buy-now-btn"
          onClick={ev => this.addToCart(ev)}
        >
          {BUY_NOW_CAPS}
        </button>
      );
    }
    let exchangeFreeText;
    let exchangeText;
    if (this.isExchange && EXCHANGE_CONFIG) {
      const exchangeConfig = JSON.parse(EXCHANGE_CONFIG);
      exchangeFreeText = exchangeConfig && exchangeConfig.EXCHANGE_FREE_TEXT;
      exchangeText = exchangeConfig && exchangeConfig.EXCHANGE_TEXT;
    }
    if (imageUrls && imageUrls.length) {
      carouselInfo = this.getCarouselInfo(imageUrls);
    }
    return (
      <div className="power-types-wrapper">
        {showNearBy && (
          <LKModal
            backdrop
            keyboard
            dialogClassName="nearByStore-popup"
            hideHandler={() => this.showNearByPopup(false)}
            showModal={showNearBy}
            size="large"
          >
            <div className="nearByStore-popup_slide" style={{ overflow: 'hidden' }}>
              <NearByStoreAppointment
                brandName={productData.brandName}
                closeModal={this.showNearByPopup}
                productId={productData.id}
              />
            </div>
          </LKModal>
        )}
        {/* cross-sell section */}
        {productData.crossSells.length && productData.type !== 'Contact Lens' ? (
          <div className="text-black tickcheckbox cross-sell margin-b5">
            <label>
              <input defaultChecked type="checkbox" value="" onChange={this.toggleChange} />
              <span>
                {productData.crossSells[0] !== undefined ? productData.crossSells[0].title : ''}
              </span>
            </label>
          </div>
        ) : (
          ''
        )}
        {/* Lenses Only section */}
        {productData.brandName === 'Lenses Only' && (
          <LensOnlyAvailability
            dataLocale={dataLocale}
            enterLocationAddToCart={this.props.enterLocationAddToCart}
            handleChange={this.handleChange}
            invalidPinCode={invalidPinCode}
            pickLocationaddTocart={this.pickLocationaddTocart}
          />
        )}
        {productData.type !== 'Contact Lens' && (
          <div className={`select-power-types ${isEye ? 'eyeframe' : ''}`}>
            {/* show qty for specific products */}
            {(productData.sku?.indexOf('watch:') !== -1 ||
              ((productData.brandName === 'Vincent Chase' ||
                productData.brandName === 'Lenskart') &&
                productData.classification === 'accessories_revenue')) && (
              <div className="qty-panel">
                {' '}
                <div className="qty-box">
                  <span>{QUANTITY}</span>
                  <input
                    ref="qtyValue"
                    type="text"
                    value={itemQtyValue}
                    onBlur={event => this.itemOnBlurHandler(event)}
                    onChange={event => this.itemChangeValue(event)}
                  />
                </div>
              </div>
            )}
            {/* CTA Add to Cart logic or Eye/Sun/Contant Lens etc */}
            <div className="btn-add-to-cart btn-add-to-cart-sun">
              {isEye && btnAddToCartForEye}
              {isSun && btnAddToCartForSun}
              {isAccessories && btnAddToCartForAccessories}
              {isClSolution && btnAddToCartForAccessories}
              {isNonPower && btnAddToCartForNonPower}
              {isPharmaAccessories && btnAddToCartForAccessories}
            </div>
            {(!redisCommonData?.ENABLE_CYGNUS &&
              (isTryOnSwitchCTA || productData.headturnMale || productData.headturnFemale)) ||
              (redisCommonData?.ENABLE_CYGNUS && isTryOnSwitchCTA && (
                <div
                  className="flex-center try-on-btn"
                  onClick={() => this.fnCreateMyDitto('Try On', productData)}
                >
                  <span className={` ${isEye ? 'eye' : 'sun'} try-on-text`}>{TRY_ON}</span>
                  <figure>
                    <img
                      alt={TRY_ON}
                      className="pdp-model"
                      src="https://static.lenskart.com/media/desktop/img/pdp/try_on_model.png"
                      title={TRY_ON}
                    />
                  </figure>
                </div>
              ))}
          </div>
        )}
        {((productData.type === 'Contact Lens' &&
          productData.classification === 'contact_lens_solution') ||
          productData.classification === 'loyalty_services' ||
          productData.classification === 'Services' ||
          (productData.type === 'Contact Lens' &&
            productData.brandName === 'Lenskart' &&
            productData.classification === 'accessories_revenue')) && (
          <div className="row power-type padding-10">
            <div className="clearfix margin-b5" />
            {productData.classification !== 'loyalty_services' &&
              productData.classification !== 'Services' && (
                <div className="qty-panel">
                  {' '}
                  <div className="qty-box">
                    <span>{QUANTITY}</span>
                    <input
                      ref="qtyValue"
                      type="text"
                      value={itemQtyValue}
                      onBlur={event => this.itemOnBlurHandler(event)}
                      onChange={event => this.itemChangeValue(event)}
                    />
                  </div>
                </div>
              )}
            <div className="btn-add-to-cart padding-10">
              <button
                className="btn btn-topaz bg-color-primary buy-now-btn"
                style={{
                  display: 'block',
                  width: '100%',
                }}
                onClick={ev => this.addToCart(ev)}
              >
                {BUY_NOW_CAPS}
              </button>
            </div>
          </div>
        )}
        {showPowerTypeModal && (
          <NavigationDrawer dialogClassName="power-type-modal" open={showPowerTypeModal}>
            {carouselInfo && (
              <div className={`product-img-carousel inline-block${isWindows ? ' window-os' : ''}`}>
                <div className="display-flex align-items-center" style={{ height: '100%' }}>
                  <Carousel
                    carouselConfig={carouselInfo.settings}
                    carouselHtmlData={carouselInfo.htmlData}
                  ></Carousel>
                </div>
              </div>
            )}
            <div className="product-pkg-selection inline-block">
              <PowerTypeModalHeader
                changeTab={index => this.changeLensPackageTab(index)}
                closePowerTypeModal={() => this.closePowerTypeModal()}
                frameColour={frameColour}
                frameShape={frameShape}
                frameType={frameType}
                selectedPowerType={selectedPowerType}
                showSkipPowerTypeModal={this.showSkipPowerTypeModal}
                tabData={powerTab}
                type={type}
              />
              {selectedIndex === 0 && (
                <PowerTypeModal
                  dataLocale={dataLocale}
                  displayRedirectPopup={this.displayRedirectPopup}
                  frameShape={frameShape}
                  frameType={frameType}
                  productData={productData}
                  redisCommonData={redisCommonData}
                  selectedPowerTypeTab={selectedPowerType}
                  setPowerType={this.setPowerType}
                  showSkipPowerTypeModal={this.showSkipPowerTypeModal}
                  studioEnable={studioFlow?.enable}
                />
              )}
              {selectedIndex === 1 && showPackagesModal && !showCoatingModal && (
                <PackagesModal
                  addToCart={this.showSkipCoatingModal}
                  dataLocale={dataLocale}
                  displayPrice={displayPrice}
                  exchangeBalance={exchangeBalance}
                  exchangeFreeText={exchangeFreeText}
                  exchangeText={exchangeText}
                  isExchange={this.isExchange}
                  lensPackageModalClose={this.lensPackageModalClose}
                  packagesConfig={packagesConfig}
                  showPackagesModal={showPackagesModal}
                  {...this.props}
                  isLoader={isLoader}
                />
              )}
              {selectedIndex === 1 && showCoatingModal && !showPackagesModal && (
                <AddPackageCoatings
                  addCoatings={(coatings, addonsTotal) => {
                    this.addCoating(selectedLensPackage, coatings, addonsTotal);
                  }}
                  coatingModalClose={this.coatingModalClose}
                  currencyMark={currencyMark}
                  dataLocale={dataLocale}
                  isExchange={this.isExchange}
                  selectedLensPackage={selectedLensPackage}
                  showCoatingModal={showCoatingModal}
                  {...this.props}
                  goToBackStep={() => {
                    this.goToBackStep();
                  }}
                />
              )}
              {selectedIndex === 2 && (
                <EyePowerSubmitInfo
                  addonsTotal={addonsTotal}
                  continueEyePower={() => this.continueEyePower()}
                  currencyMark={currencyMark}
                  dataLocale={dataLocale}
                  productData={productData}
                  redisCommonData={redisCommonData}
                  selectedCoating={selectedCoating}
                  selectedIndex={selectedIndex}
                  selectedLensPackage={selectedLensPackage}
                ></EyePowerSubmitInfo>
              )}
            </div>
          </NavigationDrawer>
        )}
        {studioFlow?.enable && showRedirectPopup && !redisCommonData?.STUDIO_FLOW_WEB && (
          <NavigationDrawer dialogClassName="power-type-modal" open={showRedirectPopup}>
            <div className="product-redirect-popup">
              <div className="display-flex justify-content-between">
                <Logo appLogo={appLogo} dataLocale={dataLocale} />
                <div onClick={() => this.setState({ showRedirectPopup: false })}>
                  <img alt="close" className="cursor-pointer" src="/assets/svg/Cross.svg" />
                </div>
              </div>
              <div className="display-flex flex-column align-items-center">
                <div className="redirect-heading">{ITEM_CURRENTLY_ON_APP}</div>
                <p className="redirect-text">{SCAN_QR_TO_DOWNLOAD_AND_PROCEED}</p>
                <div className="app-qrcode-link">
                  <img alt="qrcode-popup" className="img-app-qrcode" src={studioFlow?.qrImage} />
                  <img
                    alt="app-play-store"
                    className="img-app-play-store"
                    src="https://static1.lenskart.com/media/desktop/img/SG/desktop_icons/app_play_store.png"
                  />
                </div>
              </div>
            </div>
          </NavigationDrawer>
        )}
        {showTryOnPopUp && getSetCookie.getCookie('isDittoID') && (
          <TryOnPopUp
            close={this.close}
            productData={productData}
            redisCommonData={redisCommonData}
            showTryOnPopUp={showTryOnPopUp}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  redisCommonData: state.common.redisCommonData,
  enterLocationAddToCart: state.product.enterLocationAddToCart,
  location: state.router.location,
  getLensPackagesFailed: state.product.getLensPackagesFailed,
  isLoader: state.product.loadingPackage,
  LensPackage: state.product.getLensPackages,
  dataLocale: state.locale,
  modifiedProductData: state.product.modifiedProductData,
  currencyMark: state.common.currencyMark,
  exchangeBalance: state.product.exchangeBalance,
  appLogo: state.common.appLogo,
  categoryData: state.common.categoryData,
});

function mapDispatchToProps(dispatch) {
  return {
    productCallsAction: bindActionCreators(productCallsActionCreators, dispatch),
    cartCallsAction: bindActionCreators(cartCallsActionCreators, dispatch),
    commonCallsAction: bindActionCreators(commonCallsActionCreators, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectPowerTypes);
